define(function(require) {
    var _ = require('underscore');

    var Local = function() {
        this.initialize.apply(this, arguments);
    };

    _.extend(Local.prototype, {
        initialize: function(){},

        read: function (key) {
            return localStorage.getItem(key);
        },

        write: function (key, data) {
            try {
                localStorage.setItem(key, data);
            }
            catch(e) {
                if (e.name == 'QuotaExceededError') {
                    localStorage.clear();
                }
            }
        },

        each: function (fn) {
            for (var i = localStorage.length - 1; i >= 0; i--) {
                var key = localStorage.key(i);
                fn(this.read(key), key)
            }
        },

        remove: function (key) {
            localStorage.removeItem(key);
        },

        clearAll: function () {
            localStorage.clear();
        }
    });

    var Memory = function() {
        this.memory = {};
        this.initialize.apply(this, arguments);
    };

    _.extend(Memory.prototype, {
        initialize: function () {},

        read: function (key) {
            return this.memory[key];
        },

        write: function (key, data) {
            this.memory[key] = data;
        },

        each: function (fn) {
            for (var key in this.memory) {
                if (this.memory.hasOwnProperty(key)) {
                    callback(fn[key], key)
                }
            }
        },

        remove: function (key) {
            delete this.memory(key);
        },

        clearAll: function () {
            this.memory = {};
        }
    });

    var Storage = function() {
        var testKey = '' + Date.now();

        try {
            localStorage.setItem(testKey, '1');
            localStorage.removeItem((testKey));
            this.storage = new Local();
        } catch (e) {
            this.storage = new Memory();
        }
        this.initialize.apply(this, arguments);
    };

    _.extend(Storage.prototype, {
        initialize: function() {},

        read: function(key) {
            return this.storage.read(key);
        },

        write: function(key, data) {
            return this.storage.write(key, data);
        },

        each: function(fn) {
            return this.storage.each(fn);
        },

        remove: function(key) {
            return this.storage.remove(key);
        },

        clearAll: function() {
            return this.storage.clearAll()
        }
    });

    return Storage
});